module.exports = __webpack_public_path__ + "img/banner-transformers.2ab7a808.png";